import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,[_c(VCardTitle,[_c('span',{staticClass:"text-sm font-weight-semibold"},[_vm._v("Revenue Report")]),_c(VSpacer),_c(VChip,{staticClass:"v-chip-light-bg secondary--text font-weight-semibold",attrs:{"small":""}},[_vm._v(" This Year ")])],1),_c('vue-apex-charts',{attrs:{"height":"250px","options":_vm.chartOptions,"series":_vm.chartData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }